var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 149084",
    width: 24,
    height: 24,
    transform: "translate(156 460)",
    fill: "#b7b7b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156 -460)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.686 416.645)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12649",
    transform: "translate(0 47.104)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10397",
    d: "M18.161,49.974H16.008L14.82,48.18A2.47,2.47,0,0,0,12.78,47.1H7.847a2.47,2.47,0,0,0-2.04,1.076L4.619,49.974H2.466A2.459,2.459,0,0,0,0,52.44v8.7a2.459,2.459,0,0,0,2.466,2.466H18.161a2.459,2.459,0,0,0,2.466-2.466v-8.7A2.459,2.459,0,0,0,18.161,49.974ZM10.314,61.588a5.549,5.549,0,1,1,5.56-5.538A5.559,5.559,0,0,1,10.314,61.588Zm7.533-8.139H16.86a.729.729,0,0,1,0-1.457h.9a.728.728,0,0,1,.762.7A.71.71,0,0,1,17.847,53.449Z",
    transform: "translate(0 -47.104)",
    fill: "#b7b7b7"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12651",
    transform: "translate(7.22 52.956)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10398",
    d: "M167.958,180.736a3.083,3.083,0,1,0,3.094,3.072A3.1,3.1,0,0,0,167.958,180.736Z",
    transform: "translate(-164.864 -180.736)",
    fill: "#b7b7b7"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.0a66dc9a.svg";
export { ForwardRef as ReactComponent };